import api from 'api/ApiClient';

import { getShippingCost } from './selectors';
import { getVariants } from 'common/selectors';

api.setCsrfToken();

const { gon } = window;
const { current_order: currentOrder, products } = gon;
const subscribed = gon.user ? gon.user.subscribed : false;

const initialState = {
  addToCartSuccessQuantity: null,
  canBecomeMember: gon.can_become_member,
  commitmentDetailsIsOpen: false,
  commitmentUpsellModalIsOpen: false,
  currentOrder,
  flashMessages: [],
  freeShippingAmount: gon.freeShippingAmount,
  hasSavedCart: false,
  isOpen: false,
  lineItemsCount: null,
  lineItemsPending: [],
  lineItemsProcessing: [],
  membershipDiscountRate: gon.membership_discount_rate,
  minimumSubscriptionItems: gon.minimumSubscriptionItems,
  nicotineStrengthDetailsIsOpen: false,
  quickShopIsOpen: false,
  selectedQuickShopVariant: null,
  quickShopVariants: [],
  pendingPrice: 0,
  pendingQuantity: 0,
  products,
  sidebarIsFocused: false,
  standardShippingCost: gon.standardShippingCost,
  subscribableVariantDiscountRate:
    gon.eligible_subscription_plan_params &&
    gon.eligible_subscription_plan_params['subscribable_variant_discount_rate'],
  subscribableVariantFreeFrequency:
    gon.eligible_subscription_plan_params &&
    gon.eligible_subscription_plan_params[
      'subscribable_variant_free_frequency'
    ],
  splitTreatments: null,
  subscribed,
  variantsSaving: [],
};

initialState.variants = getVariants(initialState);
initialState.shippingCost = getShippingCost(initialState);

export default initialState;
